var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80016 1.20844C1.30803 2.97667 -1.14166 8.97248 0.699666 14.6923C1.63405 17.3857 3.15363 19.8066 5.15014 21.7926C7.88899 24.4527 10.8979 26.7936 14.1325 28.7826L14.4997 29.0025C14.8515 29.2131 15.2916 29.2093 15.6398 28.9929L15.9827 28.7799C19.2128 26.7936 22.2217 24.4527 24.9512 21.8019C26.9571 19.8066 28.4767 17.3857 29.4033 14.7158C31.2512 8.97595 28.7915 2.9773 23.2977 1.20853L22.9002 1.09018C20.3814 0.397396 17.7047 0.738763 15.4482 2.01629L15.0472 2.25404L14.6532 2.01761C12.2731 0.667171 9.42879 0.362901 6.80016 1.20844ZM14.1166 4.2584L14.411 4.46947C14.7989 4.7473 15.3223 4.74178 15.7043 4.45582C17.6938 2.96643 20.2686 2.53301 22.6273 3.28972C26.8838 4.66014 28.821 9.38419 27.3277 14.0229C26.5178 16.3559 25.1771 18.4919 23.4163 20.2433L22.6265 20.9937C20.4985 22.9713 18.1973 24.7615 15.7538 26.3391L15.0541 26.7791L15.2675 26.9138C12.1809 25.0155 9.29875 22.7734 6.68411 20.2341C4.93282 18.4919 3.59212 16.3559 2.77435 13.9995C1.28749 9.37978 3.2162 4.65906 7.47049 3.28937C9.71692 2.56677 12.1661 2.92503 14.1166 4.2584Z",
    fill: "#394357"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.a8ed4466808e341ecbde672f30849b97.svg";
export { ForwardRef as ReactComponent };